"use client"

import ContactUsSection from "./ContactUsSection"

const ContactSection = ({ onHealthcareClick, onPatientClick, onCMIClick, onTipsClick }) => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-stone-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* <ProductInfoSection onCMIClick={onCMIClick} onTipsClick={onTipsClick} /> */}
        <ContactUsSection onHealthcareClick={onHealthcareClick} onPatientClick={onPatientClick} />
      </div>
    </section>
  )
}

export default ContactSection